import { deepArticles } from "@/mocks/crash";
import SectionHeading from "./SectionHeading";

export default function DeepDives() {
  const [featured, ...rest] = deepArticles;

  return (
    <section id="deep" className="relative bg-paper-100/70 py-16 md:py-24 scroll-mt-16">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="FEATURE STORY · 深度专题"
            title="不止于吃瓜，看懂背后的真相"
            desc="从人设经济学到滤镜工业、从粉丝心理到公关手册，用媒体人的视角，把每一次幻灭拆成可被理解的逻辑。"
          />
          <a
            href="#manual"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-ink-900 px-5 py-2.5 text-ink-900 hover:bg-ink-900 hover:text-paper-50 text-sm font-semibold transition-colors"
          >
            进入吃瓜手册 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <article className="group mt-10 grid grid-cols-1 lg:grid-cols-2 overflow-hidden rounded-2xl border border-paper-200 bg-paper-50">
          <div className="relative aspect-[16/10] lg:aspect-auto overflow-hidden">
            <img
              src={featured.img}
              alt={`深度专题：${featured.title} 的配图`}
              className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute top-4 left-4 rounded-full bg-coral-500 text-white text-xs font-semibold px-3 py-1">
              {featured.tag}
            </span>
          </div>
          <div className="flex flex-col justify-center p-6 md:p-10">
            <p className="text-xs uppercase tracking-[0.25em] text-coral-600 font-semibold">
              Issue 深度推荐
            </p>
            <h3 className="mt-3 text-2xl md:text-3xl font-display leading-snug group-hover:text-coral-700 transition-colors">
              {featured.title}
            </h3>
            <p className="mt-4 text-ink-700/85 leading-relaxed">{featured.summary}</p>
            <div className="mt-6 flex items-center gap-4 text-xs text-ink-700/55">
              <span className="inline-flex items-center gap-1">
                <i className="ri-time-line"></i> 阅读约 {featured.minutes} 分钟
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-eye-line"></i> {featured.reads} 人已读
              </span>
            </div>
          </div>
        </article>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {rest.map((a) => (
            <article
              key={a.title}
              className="group flex flex-col overflow-hidden rounded-2xl border border-paper-200 bg-paper-50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={a.img}
                  alt={`深度专题：${a.title} 的配图`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute bottom-3 left-3 rounded-full bg-paper-50/90 text-ink-900 text-xs font-semibold px-3 py-1">
                  {a.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h4 className="text-base font-semibold leading-snug group-hover:text-coral-700 transition-colors">
                  {a.title}
                </h4>
                <p className="mt-2 text-sm text-ink-700/75 leading-relaxed line-clamp-3">{a.summary}</p>
                <div className="mt-auto pt-4 flex items-center justify-between text-xs text-ink-700/55">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line"></i> {a.minutes} 分钟
                  </span>
                  <span className="inline-flex items-center gap-1 text-coral-600 font-medium">
                    全文解读 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}